import React from 'react';
import DailyBoxes from '../DailyBoxes';
import { useAuctionState } from '../../hooks/useAuctionState';
import { useContribution } from '../../hooks/useContribution';
import { AuctionContext } from '../../context/AuctionContext';
import { useContext } from 'react';
import { DEX_LISTING_DAY } from '../../utils/constants';

/**
 * Daily Boxes Section component
 * Displays the 50 daily auction boxes
 */
const DailyBoxesSection = () => {
  const { auctionState = {}, currentDay = 1 } = useAuctionState();
  const { handleDayClick = () => {} } = useContribution();
  const { projectedContributions = {} } = useContext(AuctionContext);
  
  return (
    <DailyBoxes
      dailyAllocations={auctionState.dailyAllocations || []}
      currentDay={currentDay}
      handleDayClick={handleDayClick}
      projectedContributions={projectedContributions}
      // Include Day 51 as a proper box next to Day 50
    />
  );
};

export default DailyBoxesSection;
